import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { TituloReceberReferenciaDataSelectComponent } from './titulo-receber-referencia-data-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TituloReceberReferenciaDataSelectComponent
    ],
    exports: [
        TituloReceberReferenciaDataSelectComponent
    ]
})
export class TituloReceberReferenciaDataSelectModule { }
